import { PopupManager } from 'managers/PopupManager'
import { signal } from 'services/SignalsService'
import { SpinCheckService } from 'services/SpinCheckService'

const data = {
  count: 0,
  loss: 0,
}

signal.on('BUTTON:spin', start)
signal.on('STATE:IN:AUTO', spin)
signal.on('BUTTON:autostop', stop)
signal.on('POPUP:show', stop)
signal.on('AUTO:OFF', () => {
  data.count = 0
})

function start() {
  if (game.models.ModeModel.auto) {
    data.count = game.models.AutoCountModel.getValue()
    data.loss = 0
  }
}

function stop() {
  data.count = 0
}

function spin() {
  data.count -= 1
  data.loss += game.models.BetModel.getValue()
}

function checkFreeSpins() {
  return (
    !game.models.FreespinModel.get().left &&
    !game.models.BonusMultiplierModel.isFS
  )
}

function checkLimit() {
  data.loss -= game.models.WinModel.get().winLines.length
    ? game.models.BetModel.getValue()
    : 0

  const ok =
    data.loss < game.models.AutoLimitModel.getType('loss') &&
    game.models.WinModel.get().totalWin <
      game.models.AutoLimitModel.getType('win')
  if (!ok) {
    stop()
    if (!game.models.BonusMultiplierModel.isFS) {
      PopupManager.show('limitExceeded')
    }
  }
  return ok
}

export const AutoSpinManager = {
  isAllowed,
  count,
}

function isAllowed() {
  if (game.models.GameModel.requestAgainAllowed) {
    stop()
  }
  return (
    data.count > 0 &&
    SpinCheckService.checkBalance() &&
    checkLimit() &&
    checkFreeSpins()
  )
}

function count() {
  return data.count
}
